function authError(idenitifier, message) {
	let element = $('[data-form="error"]').filter(`[for=${idenitifier}]`);
	let html = ``;
	
	html = `<span class="form__error">${message}</span>`;
	element.html(html);
}